module.exports = "/_next/static/images/lknalog_3-f35526b6e04fab4ef70d31011f0c1186.png";